import { render, staticRenderFns } from "./aiCo.vue?vue&type=template&id=51646316&scoped=true"
import script from "./aiCo.vue?vue&type=script&lang=js"
export * from "./aiCo.vue?vue&type=script&lang=js"
import style0 from "./aiCo.vue?vue&type=style&index=0&id=51646316&prod&lang=scss&scoped=true"
import style1 from "./aiCo.vue?vue&type=style&index=1&id=51646316&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51646316",
  null
  
)

export default component.exports